/**
 * Decode a JWT payload with proper UTF-8 support.
 * Standard atob() fails on non-ASCII characters like "ß".
 */
export function decodeJwtPayload(token: string): Record<string, any> {
  const base64 = token.split('.')[1] ?? '';
  const base64Fixed = base64.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64Fixed);
  const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}

export function base64ToBlob(base64: string, mime: string): Blob {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

export function eventStatusMapper(status: string) {
  let statusText = '';
  switch (status) {
    case '28':
      statusText = 'In Planung'
      break;
    case '30':
      statusText = 'Aktiv'
      break;
    default:
      statusText = `Unbekannt (${status})`
      break;
  }
  return statusText
}

export function eventTypeMapper(text: string) {
  let eventText = '';
  switch (text) {
    case 'momentus':
      eventText = 'Momentus Ausstellerportal'
      break;
    case 'axess':
      eventText = "Aussteller Ticketportal"
      break;
    default:
      eventText = `Unbekannt (${text})`
      break;
  }
  return eventText
}

export function eventIconMapper(iconText: string) {
  let iconcss = '';
  switch (iconText) {
    case 'momentus':
      iconcss = 'pi pi-calendar'
      break;
    case 'axess':
      iconcss = "pi pi-users"
      break;
    case 'neureuther':
      iconcss = "pi pi-shield"
      break;
    case 'conteo':
      iconcss = "pi pi-building"
      break;
    default:
      iconcss = `pi pi-bookmark`
      break;
  }
  return iconcss
}

export function formatDate(dateString: string) {
  return new Date(dateString).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}